
import uuid from 'react-uuid';

export const mapChatMessageToSearchResult = (assistantMessage: ChatMessage): SearchResult => {
    // console.log("user message:", userMessage)
    // console.log("assistant message:", assistantMessage)

    let chatCitations: SearchResultCitation[] = []
    let generatedTextWithInLineCitations: (string | SearchResultCitation)[] = []
    if (assistantMessage.citations) {
        let running_number = 1
        let next_start = 0
        assistantMessage.citations.forEach((c) => {
            // console.log("citations:", c)
            c.references.forEach((r) => {
                const citation = {
                    display_type: r.s3_path[1],
                    main_title: r.s3_path[3],
                    encoded_url: r.s3_path[4],
                    no: running_number++,
                    start: c.start,
                    end: c.end,
                    content: r.content_text,
                    title: r.title,
                    url: r.url,
                    s3_path: r.s3_path,
                    chunk_id: r.chunk_id
                }
                chatCitations.push(citation);
                if (next_start <= c.start) {
                    generatedTextWithInLineCitations.push(assistantMessage.assistant_reply.slice(next_start, c.end - 1))
                }
                generatedTextWithInLineCitations.push(citation)
                next_start = c.end - 1
            })
        });
        if (next_start < assistantMessage.assistant_reply!.length) {
            generatedTextWithInLineCitations.push(assistantMessage.assistant_reply.slice(next_start))
        }
    }
    // console.log("chat Citations:", chatCitations)
    // console.log("generatedTextWithInLineCitations :", generatedTextWithInLineCitations)
    // console.log("assistantMessage:", assistantMessage)
    // console.log("userMessage:", userMessage)
    const searchResult: SearchResult = {
        id: uuid(),
        messageId: assistantMessage.message_id,
        userQuery: assistantMessage.user_query,
        generatedText: assistantMessage.assistant_reply,
        genratedTextWithInlineCitations: generatedTextWithInLineCitations,
        citations: chatCitations,
        classification: assistantMessage.classification,
        generatedTextCreatedAt: assistantMessage.createdAt,
        feedbackRating: assistantMessage.feedbackRating,
        feedbackComment: assistantMessage.feedbackComment,
        clipboardActivityCount: assistantMessage.clipboardActivityCount,
    }
    // console.log("searchResult:", searchResult)
    return searchResult
}